export default __webpack_public_path__ + "static/media/GalanoGrotesque-Light.5fceb5f9.woff2";